const enImages = {};
export {enImages};
